/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $HomeMatchList = {
    type: 'array',
    contains: {
        type: 'HomeMatch',
    },
} as const;
